import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['contactPreferenceEmail', 'emailInput', 'contactPreferencePhone', 'phoneInput']

  connect() {
    this.toggleContactPreference()
  }

  toggleContactPreference() {
    if (this.contactPreferenceEmailTarget.checked) {
      this.emailInputTarget.style.display = "block";
      this.phoneInputTarget.style.display = "none";
    } else if (this.contactPreferencePhoneTarget.checked) {
      this.emailInputTarget.style.display = "none";
      this.phoneInputTarget.style.display = "block";
    } else {
      this.emailInputTarget.style.display = "none";
      this.phoneInputTarget.style.display = "none";
    }
  }
}
